import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {InputLabel, FormControl, Select as MaterialSelect  ,Box ,TextField,
  FormControlLabel, LinearProgress, Checkbox, Typography, IconButton,
RadioGroup, Radio, MenuItem, Select,
Tooltip} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import {toast} from "react-toastify";
import {ErrorGeneral, llamaApiCargaToken, llamadaApiToken} from "../funciones/ClienteAxios";
import Modal from '../Generales/ModalInformativo';
import Rating from '@material-ui/lab/Rating';
import CloseIcon from '@material-ui/icons/Close';
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      }, 
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
      selectEmpty: {
        marginTop: theme.spacing(2),
      },
      Textnumero: {
        width: 5+"px",
      },
      formControlFull: {
        //margin: theme.spacing(1),
        //minWidth: 120,
        width:5+"rem"
      },
      margin: {
        margin: theme.spacing(1),
      },
    },
  }));

const NvoEditRelacionMaquinaria = ({modalAbierto, setModalAbierto, titulo, funcionActuliza, seguro, listMaquina }) => {
  let history = useHistory();
  const classes = useStyles();
  const source = axios.CancelToken.source(); 
  const idusu = localStorage.getItem('UsuId');
  const [espera,setEspera]=useState(false);
  const [mensaje, setMensaje] = useState('');
  const [tipoAdvertencia, setTipoAdvertencia] = useState('success');
  const [aviso, setAviso] = useState(false); 
  const [btnDesact, setBtnDesact] = useState(false); 
  const [listAllMaquinas, setListAllMaquinas] = useState([]); 
  const [listOriginal, setListOriginal] = useState([]); 
  const [listado, setListado] = useState([]); 
  //const [listMaquinas, setListMaquinas] = useState([]); 
  const [registro, setRegistro]= useState({Orden:0, Alias:"", Descr:"", });  
  const {Orden,  Descr, }=registro        
  
  React.useEffect(()=>{     
    // console.log(seguro,listMaquina);
    if (seguro.length !== 0 ) {
      setRegistro({...registro,    Orden:seguro.Id,  })        
    }
    getListAllMaquinaria()
    if (listMaquina.length!==0 && listMaquina[0].MaqId!==0) {
          setListado(listMaquina)
    }


    return ()=> {
      source.cancel();
    }     
    // eslint-disable-next-line react-hooks/exhaustive-deps	
  },[]);

  const getListAllMaquinaria = () => {    
    const data = qs.stringify({
        Usuario:idusu,        
        ip: "127.0.0.0",             
        idDispositivo: "8978yuhjnfrsdsd"
    });
    const url = "/maquinaria";

    function respuesta(auxiliar) 
    { 
        if (auxiliar[0].Id !== -1) 
        { let nvoArr=auxiliar      

          if (listMaquina.length!==0) {
            listMaquina.forEach(element => {
              const nvoFiltro = nvoArr.filter((maquina)=> maquina.Id+"" !== element.MaqId+"" && maquina.Id !==0 )    
              if (nvoFiltro.length!==0) {
                nvoArr= nvoFiltro
              }
            });
          }
         // console.log(nvoArr);
          
          setListOriginal(auxiliar)
          setListAllMaquinas(nvoArr)
        }
    }
    llamadaApiToken(data, url, respuesta, ErrorGeneral,  history, source);
  };
  

  const registrarNActividad=(auxArr)=>{               
  
    //let NomUsu= localStorage.getItem('UsuarioNom');  
    const data = qs.stringify({
      Seguro:Orden,
      Usuario:idusu,                              
      Status:1,      
      Relacion:JSON.stringify([auxArr] ),
      ip:"172.2.0.0",      
      idDispositivo:'8978yuhjnfrsdsd'
    });
    const url = "/maquinaria/seguro/relacion/edit";
  
    function respuesta(aux) {
      if (aux.resultado.length!==0) 
      { //console.log(aux);
        let mensaje= aux.resultado[0].id!==0 ?
        `Se edito correctamente el registro "${seguro.Poliza} " `        
        :`Se Registro correctamente la maquinaria la seguro `
        setTipoAdvertencia("success")      
        setMensaje(mensaje);
        setAviso(true)     
        toast.success(mensaje, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });       
        funcionActuliza()
        //setModalAbierto(false)            
      }   
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);     
  }

  const onChange = e =>
  { let expNopermitida = new RegExp('[#_:$%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9!]');
    if ((expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value) )||e.target.value===' '||e.target.value==='') 
    {
    
      setRegistro({ ...registro, [e.target.name] : e.target.value  })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };
  
  const onChangeListAll=(e)=>{        
        
    const nvoFiltro = listAllMaquinas.filter((maquina)=> maquina.Id+"" !== e.target.value+"" )    
    const nvoFiltro2 = listAllMaquinas.filter((maquina)=> maquina.Id+"" === e.target.value+"" )  
    const auxFiltro= nvoFiltro2[0]    
    if (nvoFiltro.length!==0) {
      setTimeout(()=>{
        setListAllMaquinas(nvoFiltro)
        registrarNActividad({"maq":auxFiltro.Id,"st":"1"}   )
         
      },200)
      setListAllMaquinas([]) 
      let nvoarr=[]
      nvoarr.push({...auxFiltro, MaqAlias:auxFiltro.Descr, MaqNoEco:auxFiltro.NoEco, MaqSerie:auxFiltro.Serie, MaqId:auxFiltro.Id  })
      nvoarr.push(...listado  )      
      //console.log(nvoarr);      
      setListado(nvoarr) 
    }         
  }

  const onDeleteListado =(auxId)=>{        
    let nvoArr=[]  
    const filtro = listado.filter((maquina)=> maquina.MaqId+"" !== auxId+"" )    
    if (filtro.length!==0) {
      filtro.forEach(element => {
        const nvoFiltro = listOriginal.filter((maquina)=> maquina.Id+"" !== element.MaqId+"" && maquina.Id !==0 )    
        if (nvoFiltro.length!==0) {
          nvoArr= nvoFiltro
        }
      });
      registrarNActividad({"maq":auxId,"st":"0"}   )
    }
    setListAllMaquinas(nvoArr)    
    setListado(filtro) 
  }         
  


  const onChangeColor = e =>
  {
    setRegistro({ ...registro,Color: e.target.value })
  };

  const validaDatos=(valor, mensaje)=>{
    let respuesta=false    
    if (valor!= null && valor!= '' && valor!= '0' && valor!== 0 ) 
    { respuesta=true     
    }
    else
    { setTipoAdvertencia("warning")    
      setMensaje(mensaje);
      setAviso(true)     
    }
    return respuesta
  }
/* 
  const guardarDatos = () => 
  {    
    if ( ((Descr.length>=5 && validaDatos(Descr, "Llenar campo de Nombre (mayor a 5 caracteres)") ))
      || (Descr.length<5 && validaDatos(0, "Llenar campo de Nombre (mayor a 5 caracteres)"))
    ) 
    {        
      registrarNActividad()                                                                                                 
    }                            
  }; */

  const onChangeRef = e =>
  { let expNopermitida = new RegExp('[$!?]');
    //let expMenos = new RegExp('-');
    //let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9#_:%-({})/*=|]');
    if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) ) 
        || e.target.value===' ' || e.target.value==='') 
    {    
      setRegistro({ ...registro, [e.target.name] : e.target.value  })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };

  const selectAll= <FormControl style={{   width: "40rem" ,marginRight:1+'rem'}} size="small" variant='outlined'>
    <InputLabel id="ipt-maq" variant='outlined'>Seleccione una nueva maquinaria para asignar</InputLabel>
    <Select
      labelId="lbl-select-maq" id="select-maq" variant='outlined' //name="listado" //value={listado} 
      label="Seleccione una nueva maquinaria para asignar" onChange={onChangeListAll}
    >      
      {listAllMaquinas.map((maq)=><MenuItem value={maq.Id}>{`${maq.NoEco} - ${maq.Serie} - ${maq.Descr}`}</MenuItem>)}
    </Select>
  </FormControl>
  
  return ( 
  <Modal
    titulo={titulo} modalAbierto={modalAbierto}
    setModalAbierto={setModalAbierto} guardarDatos={()=>{}}
    mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
    aviso={aviso} setAviso={setAviso} espera={espera} maxTam={true}
    setEspera={setEspera}  tamanio={"md"} btnDesact={btnDesact}
  >
  <form className={classes.root} noValidate autoComplete="off" fullWidth style={{width:42+'rem'}} >                               
    <Box display={"flex"} flexDirection={"column"} mb={2}>
      {listAllMaquinas.length !== 0 ? selectAll :null }
     <Box style={{width:25+'rem'}} mt={2}>  
      
      {listado.length !== 0 ?
        listado.map((maqui)=>{
         
        return(
        <Box display={"flex"} flexDirection={"row"} width={"42rem"}> 
        <IconButton aria-label="close" size="small" className={classes.closeButton} onClick={()=>onDeleteListado(maqui.MaqId)}>
          <Tooltip title="Eliminar">
            <CloseIcon />
            </Tooltip>
          </IconButton>
          <FormControl component="fieldset" style={{width:38+'rem'}}>    
            <Typography>{`${maqui.MaqNoEco} - ${maqui.MaqSerie} - ${maqui.MaqAlias}`}</Typography>
          </FormControl>
          
        </Box>)}) 
      :null}
      </Box>     
  {/*   <Box style={{width:25+'rem'}} mt={2}>      
      <FormControl component="fieldset" style={{width:25+'rem'}}>    
        <TextField id="outlinedAlias" variant='outlined'           
          label="Alias"  size="small"
          value={Alias} onChange={onChangeRef}  
          name="Alias" fullWidth
        /> 
      </FormControl>
      </Box>    */}  
    </Box>

      
     
      </form>
  </Modal>
  );
}
 
export default NvoEditRelacionMaquinaria;